__webpack_require__.p = "/biodiversity/sahyadri_enews/newsletter/Issue92/";